// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__KSmz5","amount":"Amount_amount__1YkYq","tip":"Amount_tip__318s7","tipHeader":"Amount_tipHeader__1yTB7","tipsWrap":"Amount_tipsWrap__3TpF7"};